import { ReactNode } from 'react';

import { ButtonsBar, Flyover } from '@labradorsports/components';

import { Panel } from '../index.js';

interface Props {
    header?: ReactNode;
    buttons?: ReactNode;
    className?: string;
    in: boolean;
    position?: 'bottom' | 'left';
    aboveModals?: boolean;
}

const FlyoverPanel: FC<Props> = ({
    in: animationIn,
    header,
    children,
    buttons,
    className,
    position = 'left',
    aboveModals,
}) => {
    return (
        <Flyover in={animationIn} position={position} aboveModals={aboveModals}>
            <Panel
                className={className}
                header={header}
                content={children}
                footer={buttons ? <ButtonsBar>{buttons}</ButtonsBar> : undefined}
            />
        </Flyover>
    );
};

export default FlyoverPanel;
